import React, { useState, useRef, useEffect } from 'react';

import { EXPORT_PLAYER } from 'common/module/ui/lazy-modal/constant-types';
import buildReactDomModalModule from 'common/module/ui/lazy-modal/react-dom-modal-module';
import ReactModal from 'common/module/ui/lazy-modal/react-modal';
import { setSelection } from 'common/tools/dom/selection';
import capitalize from 'common/tools/string/capitalize';
import trans from 'common/tools/translations/trans';

import ExportPlayerItem from 'website/components/player/ExportItem';
import { getVideoEmbedCode } from 'website/module/player/share';

type Props = {
  title: string;
  videoData: Record<string, unknown>;
};

type VideoSize = {
  width: number;
  height: number;
  txtKey: string;
};

const videoSizes: { [key: string]: VideoSize } = {
  small: {
    width: 320,
    height: 180,
    txtKey: 'moviepage_videos_trailer.exportSmall'
  },
  mid: {
    width: 480,
    height: 270,
    txtKey: 'moviepage_videos_trailer.exportMedium'
  },
  big: {
    width: 640,
    height: 360,
    txtKey: 'moviepage_videos_trailer.exportBig'
  },
  gigantor: {
    width: 960,
    height: 540,
    txtKey: 'moviepage_videos_trailer.exportXl'
  }
};

const ExportPlayerModal = ({ title, videoData }: Props) => {
  const inputSelect = useRef<HTMLInputElement>(null);

  const videoCodeExport = (
    videoData: Record<string, unknown>,
    current: string
  ) =>
    getVideoEmbedCode(
      videoData,
      videoSizes[current].width,
      videoSizes[current].height
    );

  const selectCode = () => {
    if (!inputSelect.current || !inputSelect.current.selectionEnd) {
      return;
    }

    setSelection(inputSelect.current, {
      start: 0,
      end: inputSelect.current.selectionEnd
    });
  };

  const [current, setCurrent] = useState('mid');
  const [codeExport, setCodeExport] = useState(
    videoCodeExport(videoData, current)
  );

  const changeFrameSize = (size: string) => {
    setCurrent(size);
    setCodeExport(videoCodeExport(videoData, size));
  };

  useEffect(() => {
    selectCode();
  }, [codeExport]);

  return (
    <ReactModal size="large" className="modal-player-export" title={title}>
      <form className="player-export" method="get" action="#">
        <fieldset className="field cf">
          <legend className="title">
            1. {trans('moviepage_videos_trailer.exportChoseSize')}
          </legend>

          {Object.keys(videoSizes).map(size => (
            <ExportPlayerItem
              type={size}
              id={`export${capitalize(size)}`}
              width={videoSizes[size].width}
              height={videoSizes[size].height}
              title={trans(videoSizes[size].txtKey)}
              key={size}
              checked={size === current}
              onClick={changeFrameSize}
            />
          ))}
        </fieldset>

        <fieldset className="field cf">
          <legend className="title">
            2. {trans('moviepage_videos_trailer.exportCopie')}
          </legend>

          <input
            className="input-txt"
            type="text"
            name="copyCode"
            id="player-export-input"
            value={codeExport}
            readOnly
            ref={inputSelect}
          />
          <span
            className="button button-default-full"
            id="player-export-select"
            onClick={selectCode}
          >
            {trans('moviepage_videos_trailer.exportSelect')}
          </span>
        </fieldset>
      </form>
    </ReactModal>
  );
};

export default buildReactDomModalModule(EXPORT_PLAYER, (params: Props) => (
  <ExportPlayerModal title={params.title} videoData={params.videoData} />
));
